module.exports = __webpack_public_path__ + "img/new-user-draw-btn.cba4c044.png";